export function parseOptionalInt(value: string): number | undefined {
  if (value === "") return undefined;
  const n = parseInt(value, 10);
  return Number.isNaN(n) ? undefined : n;
}
